import styled from "styled-components"

const ResumeSection = styled.section`
  margin-bottom: 2rem;
`

export default ResumeSection
